import { render, staticRenderFns } from "./ModalNovoItemAvulsoRepasse.vue?vue&type=template&id=40f7f788&scoped=true"
import script from "./ModalNovoItemAvulsoRepasse.vue?vue&type=script&lang=ts"
export * from "./ModalNovoItemAvulsoRepasse.vue?vue&type=script&lang=ts"
import style0 from "./ModalNovoItemAvulsoRepasse.vue?vue&type=style&index=0&id=40f7f788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f7f788",
  null
  
)

export default component.exports